import http from '@/api'

export const api = {
  getEvents (hallId) {
    return http.get(`/eventor/public/listevents/${hallId}`)
  }
}
